angular.module("digitalLeasing.module").component("cespiteTable", {
  templateUrl: "ng/components/digitalLeasing/goodManagement/cespiteTable/cespiteTable.view.html",
  bindings: {
    model: "=",
    pageIsOk: "&",
    pageIsNotOk: "&",
    amount: "&",
    snapshot: '<',
    portalRunned: '<',
    newCf: "&"
  },
  controllerAs: "cespiteTableCtrl",
  controller: CespiteTableController
});

function CespiteTableController(
  $modalService,
  BeneContratto,
  $financialApiService,
  $timeout,
  $rootScope,
  Tranche,
  FlagArc,
  $typeDomainService,
  $portalService,
  $financialService
) {
  var self = this;

  self.$onInit = function () {
    self.$portalService = $portalService
    self.numberOfCharMax = 20;
    self.supportModel = {
      cespitiList: [],
      totalCespitiAmount: 0,
      firstCespite: false,
      elementToAdd: {},
      allPaymentMode: [],
      enableConfButton: false,
      goodNumber: "1",
      isModifyCespite: "",
      cespiteAmount: "",
      productType: "",
      enableModal: false,
      isM12: true,
      maxAmount: false,
      singleCespite: false,
      initialAmount: "",
      insuredIsVisible: false,
      statoIsChanged: false,
      flagAllestimento: false,
      allestiObj: [],
      numberOfCespitiMax: "",
      isMaxNumOfCespiti: false,
      regimeAppIsChanged: false,
      cduIsChanged: false,
      boatIsVisible: false,
      flyIsVisible: false,
      cf: ""
    }

    //sia M12 che M15
    if (self.model.leasingData.preventivo.prodotto.beneContratto.length == 0 && self.model.leasingData.preventivo.prodotto.id != "IMC") {
      self.model.leasingData.preventivo.prodotto.beneContratto.push(BeneContratto.build({
        idBene: "1",
        importo: self.model.leasingData.preventivo.importo,
        dataDiConsegna: self.model.leasingData.preventivo.prodotto.bene.dataFirmaVerbale,
        annoCostruzione: self.model.leasingData.preventivo.prodotto.bene.annoCostruzione,
        description: self.model.leasingData.preventivo.prodotto.bene.descrizione,
        fornitore: self.model.leasingData.preventivo.fornitore
      }));
    }
    if (self.model.leasingData.preventivo.prodotto.id === "IMC" && $portalService.isAru()) {
      self.supportModel.totalCespitiAmount = self.model.leasingData.preventivo.importo;
      self.amount({
        amount: self.model.leasingData.preventivo.importo
      });
    }

    if (getWizardMap(self.model.viewIndex) == "M12") {
      self.supportModel.totalCespitiAmount = self.model.leasingData.preventivo.importo;
    }

    if (getWizardMap(self.model.viewIndex) == "M15") {
      self.supportModel.isM12 = false;
      self.showQuestionButton = true;

      self.model.leasingData.preventivo.prodotto.beneContratto.forEach(function (cespite) {
        changeModPagamento(cespite); //assegno i valori corretti di importo dilazione, perc e cfPiva
      });

      //M12
    } else {
      validateGoodManagement();
      popolateControlCheckBox();
      self.showQuestionButton = false;
    }

    //sia M12 che M15
    if (self.model.leasingData.preventivo.prodotto.beneContratto && self.model.leasingData.preventivo.prodotto.beneContratto.length > 0) {

      self.supportModel.firstCespite = true;
      self.supportModel.cespitiList = self.model.leasingData.preventivo.prodotto.beneContratto;
      self.supportModel.cespitiList.forEach(function (element) {
        self.supportModel.goodNumber = element.idBene;
        self.supportModel.cespiteAmount = element.importoCespite;
        element.modalIsOpened = true;
        element.fornitore.riferimento.email = !!element.fornitore.riferimento.email ? element.fornitore.riferimento.email : self.model.leasingData.preventivo.fornitore.riferimento.email;
        element.fornitore.riferimento.telefono = !!element.fornitore.riferimento.telefono ? element.fornitore.riferimento.telefono : self.model.leasingData.preventivo.fornitore.riferimento.telefono;
        element.fornitore.riferimento.description = !!element.fornitore.riferimento.description ? element.fornitore.riferimento.description : self.model.leasingData.preventivo.fornitore.riferimento.description;
        element.fornitore.cfPiva = !!element.fornitore.cfPiva ? element.fornitore.cfPiva : self.model.leasingData.preventivo.fornitore.cfPiva;
        element.fornitore.descrizione = !!element.fornitore.descrizione ? element.fornitore.descrizione : self.model.leasingData.preventivo.fornitore.descrizione;
        element.fornitore.descrizioneBene = !!element.fornitore.descrizioneBene ? element.fornitore.descrizioneBene : self.model.leasingData.preventivo.fornitore.descrizioneBene
      });
      if (getWizardMap(self.model.viewIndex) == "M15") {
        validateGoodManagement(true);
      }
    }

    if (
      self.model.leasingData.preventivo.prodotto.id === "MOB" ||
      self.model.leasingData.preventivo.prodotto.id === "MOZ" ||
      self.model.leasingData.preventivo.prodotto.id === "FER" ||
      self.model.leasingData.preventivo.prodotto.id === "FVM" ||
      self.model.leasingData.preventivo.prodotto.id === "GOM" ||
      self.model.leasingData.preventivo.prodotto.id === "OPS") {

      self.supportModel.productType = "strumentale";
      self.model.leasingData.preventivo.prodotto.beneContratto.forEach(function (element) {
        if (!element.strumentale.proprietarioImmobile.riUserG.sedeLegale &&
          self.model.financialCustomer.metadata.riUserG && !element.strumentale.proprietarioImmobile.riUserF.residenza) {
          element.strumentale.proprietarioImmobile.riUserG.sedeLegale = self.model.financialCustomer.metadata.riUserG.sedeLegale;
          element.strumentale.proprietarioImmobile.riUserG.sedeConsegna = self.model.financialCustomer.metadata.riUserG.sedeConsegna;
        }
      });

    } else if (self.model.leasingData.preventivo.prodotto.id === "FER") {
      self.supportModel.productType = "ferroviario";
    } else if (self.model.leasingData.preventivo.prodotto.id === "FLY" ||
      self.model.leasingData.preventivo.prodotto.id === "NAV") {
      self.supportModel.productType = "flyNav";
    }

    var totalCespiti = 0;
    if (self.model.leasingData.preventivo.prodotto.beneContratto.length == 1) {
      if (typeof self.model.leasingData.preventivo.prodotto.beneContratto[0].importoCespite == "undefined" ||
        self.model.leasingData.preventivo.prodotto.beneContratto[0].importoCespite == ""
      ) {
        self.model.leasingData.preventivo.prodotto.beneContratto[0].importoCespite = 0;
      }

      if (self.model.leasingData.preventivo.prodotto.beneContratto[0].importoCespite != 0) {
        totalCespiti = parseFloat(self.model.leasingData.preventivo.prodotto.beneContratto[0].importoCespite);
      } else {
        totalCespiti = parseFloat(self.model.leasingData.preventivo.importo);
      }
      if (!self.model.leasingData.preventivo.prodotto.beneContratto[0].cespiteIsOk) {
        self.supportModel.singleCespite = true;
      }

    } else {
      self.model.leasingData.preventivo.prodotto.beneContratto.forEach(function (element) {
        if (element.importoCespite) {
          totalCespiti = (parseFloat(totalCespiti) + parseFloat(element.importoCespite)).toFixed(2);
        }
      });
    }
    if (self.model.leasingData.preventivo.prodotto.id != "IMC" && $portalService.isAra()) {

      self.supportModel.totalCespitiAmount = totalCespiti;
    }

    self.amount({
      amount: self.supportModel.totalCespitiAmount
    });

    if (self.supportModel.totalCespitiAmount == self.model.leasingData.preventivo.importo) {
      self.supportModel.maxAmount = true;
    }

    self.model.leasingData.preventivo.assicurazioni.forEach(function (element) {
      if (element.tipoAssicurazione === "P") {
        self.supportModel.insuredIsVisible = true;
      }
    });

    if (self.model.leasingData.preventivo.prodotto.id == 'NAV' && self.supportModel.isM12) {
      self.supportModel.boatIsVisible = true;
    } else if (self.model.leasingData.preventivo.prodotto.id == 'NAV' &&
      !self.supportModel.isM12 && self.model.leasingData.preventivo.completatoArc) {
      self.supportModel.boatIsVisible = true;
    }

    if (self.model.leasingData.preventivo.prodotto.id == 'FLY' && self.supportModel.isM12) {
      self.supportModel.flyIsVisible = true;
    } else if (self.model.leasingData.preventivo.prodotto.id == 'FLY' &&
      !self.supportModel.isM12 && self.model.leasingData.preventivo.completatoArc) {
      self.supportModel.flyIsVisible = true;
    }

    checkAndEnableTooltip();
    getNumberMaxOfCespiti();
  };

  self.handleChange = function (property, value) {
    switch (property) {
      case "stato":
        self.supportModel.statoIsChanged = !self.supportModel.statoIsChanged;
        break;
      case "allestimento":
        self.supportModel.flagAllestimento = value;
        break;
      case "allestObj":
        self.supportModel.allestiObj = value;
        break;
      case "regimeApplicabile":
        self.supportModel.regimeAppIsChanged = !self.supportModel.regimeAppIsChanged;
        break;
      case "cdu":
        self.supportModel.cduIsChanged = !self.supportModel.cduIsChanged;
        break;
      default:
        break;
    }
  }

  self.modifyCespite = function (cespite, indice) {
    // jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar("scrollTo", 0); //posiziona la scollBar in top ad ogni cambio vista
    // jQuery('body').scrollTop(0) //posiziona la scollBar in top ad ogni cambio vista
    self.supportModel.enableModal = true;
    self.supportModel.isModifyCespite = "MODIFY";
    if (!cespite.importoCespite || cespite.importoCespite === 0) {
      cespite.idBene === "1" ? cespite.importoCespite = self.model.leasingData.preventivo.importo : 0;
    }

    if (cespite.idBene === "1" && cespite.stato == "") {
      cespite.stato = self.model.leasingData.preventivo.prodotto.bene.stato
    }
    if (!cespite.fornitore.modPagamento.listaTranches.length) {
      cespite.fornitore.modPagamento.listaTranches.push(self.model.leasingData.preventivo.fornitore.modPagamento.listaTranches[0]);
    }
    self.supportModel.elementToAdd = JSON.parse(JSON.stringify(cespite));
    self.supportModel.initialAmount = cespite.importoCespite;
    self.changeCespiteAmount(cespite.importoCespite);
    // $timeout(function () {
    //   $('.financial-leasing__footer').css("z-index", "-1");
    //   $modalService.openModal("insertCespiteModal");
    // }, 1000);
    self.indiceElementoSelezionato = indice;
  }

  self.addCespiteRow = function () {
    // jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar("scrollTo", 0); //posiziona la scollBar in top ad ogni cambio vista
    // jQuery('body').scrollTop(0) //posiziona la scollBar in top ad ogni cambio vista
    self.supportModel.enableModal = true;
    self.supportModel.isModifyCespite = "ADD";
    var newGoodNumber = 1;
    if (self.supportModel.totalCespitiAmount < self.model.leasingData.preventivo.importo) {
      self.supportModel.cespitiList.push(BeneContratto.build());

      self.supportModel.cespitiList.forEach(function (element) {
        if (!element.idBene) {
          element.idBene = newGoodNumber.toString();
          element.stato = self.model.leasingData.preventivo.prodotto.bene.stato
          element.annoCostruzione = self.model.leasingData.preventivo.prodotto.bene.annoCostruzione;
          element.description = self.model.leasingData.preventivo.prodotto.bene.descrizione;
          element.dataDiConsegna = self.model.leasingData.preventivo.prodotto.bene.dataFirmaVerbale;
          element.importoCespite = 0;
          //per i prodotti strumentale, flyNav e ferroviario popolo i parametri a default
          if (self.supportModel.productType && self.supportModel.productType != "") {
            element[self.supportModel.productType].clienteProprietarioImm = true;
            element[self.supportModel.productType].proprietarioImmobile.riUserG.sedeLegale = self.model.financialCustomer.metadata.riUserG.sedeLegale;
            element[self.supportModel.productType].proprietarioImmobile.riUserG.sedeConsegna = self.model.financialCustomer.metadata.riUserG.sedeConsegna;
          }

          if (self.model.leasingData.preventivo.pianoFinanziario.anticipo.importo == 0) {
            element.fornitore.accontiCompensazione = 0;
          }
          if (self.supportModel.isM12 && $portalService.isAru()) {
            element.fornitore = self.model.leasingData.preventivo.fornitore
          }
          self.supportModel.elementToAdd = JSON.parse(JSON.stringify(element));
        } else {
          newGoodNumber = parseFloat(element.idBene) + 1;
          if (!element.importoCespite || element.importoCespite === 0) {
            element.idBene === "1" ? element.importoCespite = self.model.leasingData.preventivo.importo : 0;
          }
        }
      })

      /*       $timeout(function () {
              $('.financial-leasing__footer').css("z-index", "-1");
              $modalService.openModal("insertCespiteModal");
              self.supportModel.elementToAdd.modalIsOpened = true;
            }, 1000); */
    } else {
      self.supportModel.firstCespite = true;
    }
  }

  self.removeCespite = function (cespite) {
    var index = self.supportModel.cespitiList.findIndex(function (el) {
      return el === cespite
    });
    if (index != -1) {
      self.supportModel.cespitiList.splice(index, 1);
      self.supportModel.totalCespitiAmount = self.supportModel.totalCespitiAmount - parseFloat(cespite.importoCespite);
      var newGoodNumber = parseFloat(cespite.idBene) - 1;
      self.supportModel.goodNumber = newGoodNumber.toString();
    }

    //riassegno gli idBene
    var newIdBene = 1;
    self.model.leasingData.preventivo.prodotto.beneContratto.forEach(function (element) {
      element.idBene = newIdBene.toString();
      newIdBene++;
    });

    if (self.supportModel.totalCespitiAmount < self.model.leasingData.preventivo.importo) {
      self.supportModel.maxAmount = false
      self.supportModel.singleCespite = false;
    } else {
      self.supportModel.maxAmount = true;
    }

    self.changeAmount(self.supportModel.totalCespitiAmount);

    if (self.model.leasingData.preventivo.prodotto.beneContratto.length >= self.supportModel.numberOfCespitiMax) {
      self.supportModel.isMaxNumOfCespiti = true;
    } else {
      self.supportModel.isMaxNumOfCespiti = false;
    }
  }

  self.saveCespiteInfo = function (cespite) {

    self.restIsPending = true;

    if (!self.supportModel.elementToAdd.idBene) {
      self.supportModel.elementToAdd.idBene = cespite.goodNumber;
    }


    var listaBene = [cespite];

    $financialService
      .validateBeneContratto(listaBene, self.model.leasingData.preventivo.prodotto.id)
      .then(function (response) {
        if (response.success) {

          var index = self.model.leasingData.preventivo.prodotto.beneContratto.findIndex(function (el) {
            return el.idBene === cespite.idBene
          });
          if (index == -1) {
            self.model.leasingData.preventivo.prodotto.beneContratto.push(cespite);
          } else {
            self.model.leasingData.preventivo.prodotto.beneContratto[index] = cespite;
          }

          self.supportModel.totalCespitiAmount = 0;

          self.model.leasingData.preventivo.prodotto.beneContratto.forEach(function (element) {
            self.supportModel.totalCespitiAmount = (parseFloat(self.supportModel.totalCespitiAmount) + parseFloat(element.importoCespite)).toFixed(2);
            if (cespite.idBene == element.idBene) {
              element.cespiteIsOk = true;
            }
          });

          if (self.supportModel.totalCespitiAmount < self.model.leasingData.preventivo.importo) {
            self.supportModel.maxAmount = false
          } else {
            self.supportModel.maxAmount = true;
          }

          if (self.model.leasingData.preventivo.prodotto.beneContratto.length == 1 &&
            self.model.leasingData.preventivo.prodotto.beneContratto[0].importoCespite != 0) {
            self.supportModel.singleCespite = false
          }
          self.changeAmount(self.supportModel.totalCespitiAmount);

          //controllo che non sia stato raggiunto il numero massimo di cespiti consentiti
          if (self.supportModel.cespitiList.length >= self.supportModel.numberOfCespitiMax) {
            self.supportModel.isMaxNumOfCespiti = true;
          } else {
            self.supportModel.isMaxNumOfCespiti = false;
          }

          validateGoodManagement();

          console.log("Bene Contratto Added: ", self.model.leasingData.preventivo.prodotto.beneContratto);
          jQuery('body').scrollTop(0);
          self.supportModel.enableModal = false;
          self.supportModel.elementToAdd = {};
        }
        self.restIsPending = false;
      }).catch(function (error) {
        self.restIsPending = false;
        console.error(error);
      });
  }

  self.changeZIndex = function (cespite) {

    if (self.supportModel.isModifyCespite === "ADD") {
      self.supportModel.cespitiList = self.supportModel.cespitiList.filter(function (el) {
        return el.idBene !== cespite.idBene
      })

      var newGoodNumber = parseFloat(self.supportModel.goodNumber) - 1;
      self.supportModel.goodNumber = newGoodNumber.toString();
    }

    self.supportModel.cespitiList.forEach(function (element) {
      if (element.idBene === cespite.idBene) {
        element.importoCespite = self.supportModel.initialAmount;
      }
    });

    self.model.leasingData.preventivo.prodotto.beneContratto = self.supportModel.cespitiList;

    $('.financial-leasing__footer').css("z-index", "1");
    $modalService.closeModal("insertCespiteModal");
    self.supportModel.enableModal = false;

  }

  self.changeAmount = function (cespiteAmount) {
    if (cespiteAmount && self.supportModel.enableConfButton) {
      self.amount({
        amount: cespiteAmount
      });
    }
  }

  self.changeCespiteAmount = function (newAmount) {
    self.supportModel.cespiteAmount = newAmount;
  }

  self.duplicaCespite = function (cespite) {
    jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar("scrollTo", 0); //posiziona la scollBar in top ad ogni cambio vista
    jQuery('body').scrollTop(0); //posiziona la scollBar in top ad ogni cambio vista
    self.supportModel.enableModal = true;
    self.supportModel.isModifyCespite = "ADD";

    var ultimoIdCespite = self.supportModel.cespitiList.length;
    var nuovoIdCespite = ultimoIdCespite + 1;
    var copiaCespite = JSON.parse(JSON.stringify(BeneContratto.build(cespite)));
    copiaCespite.modalIsOpened = false;
    copiaCespite.idBene = nuovoIdCespite.toString();
    copiaCespite.importoCespite = "0";

    if (self.model.leasingData.preventivo.prodotto.isTargato) {
      copiaCespite.targato.targaVeicolo = "";
      copiaCespite.targato.telaioVeicolo = "";
    }
    if (getWizardMap(self.model.viewIndex) == "M15") {
      copiaCespite.codiceCDU = cespite.codiceCDU;
      copiaCespite.descriptionCDU = cespite.descriptionCDU;
      copiaCespite.defaultCDU = cespite.codiceCDU;
      copiaCespite.cdCategoriaBene = "";
      copiaCespite.descriptionCatBene = "";
      copiaCespite.cduCompatibileConAssicurazioni = "";
      self.supportModel.cespiteAmount = "0";
    }

    self.supportModel.cespitiList.push(BeneContratto.build(copiaCespite));

    self.supportModel.elementToAdd = JSON.parse(JSON.stringify(copiaCespite));

    /*     $timeout(function () {
          $('.financial-leasing__footer').css("z-index", "-1");
          $modalService.openModal("insertCespiteModal");
          self.supportModel.elementToAdd.modalIsOpened = true;
        }, 1000); */

  }

  var validateGoodManagement = function (oninit) {
    var test = false;

    var cespiteOk = self.model.leasingData.preventivo.prodotto.beneContratto.every(function (x) {
      return x.cespiteIsOk
    })

    if (self.model.leasingData.preventivo.prodotto.id === "MOB" ||
      self.model.leasingData.preventivo.prodotto.id === "MOZ" ||
      self.model.leasingData.preventivo.prodotto.id === "FVM" ||
      self.model.leasingData.preventivo.prodotto.id === "GOM" ||
      self.model.leasingData.preventivo.prodotto.id === "OPS" ||
      self.model.leasingData.preventivo.prodotto.id === "FER"
    ) {

      test = (self.checkProvGood && self.checkAddGood) || cespiteOk;

    } else if (self.model.leasingData.preventivo.prodotto.id === "NAV") {

      if (self.supportModel.isM12) {
        test = self.checkProvGood && self.checkAddGood && self.checkBoat;
      } else {
        test = (self.checkProvGood && self.checkAddGood) || cespiteOk;
      }

    } else if (self.model.leasingData.preventivo.prodotto.id === "FLY") {

      if (self.supportModel.isM12) {
        test = self.checkProvGood && self.checkAddGood && self.checkFly;
      } else {
        test = (self.checkProvGood && self.checkAddGood) || cespiteOk;
      }

    } else if (self.model.leasingData.preventivo.prodotto.id === "IMM") {
      //IMMOBILIARE
      test = (self.checkProvGood && self.checkImmo) || cespiteOk;

    } else if (self.model.leasingData.preventivo.prodotto.id === "AVT" ||
      self.model.leasingData.preventivo.prodotto.id === "AVC" ||
      self.model.leasingData.preventivo.prodotto.id === "AVI" ||
      self.model.leasingData.preventivo.prodotto.id === "MOT"
    ) {
      //TARGATO
      test = (self.checkProvGood && self.checkRegistered) || cespiteOk;;
    }
    else if (self.model.leasingData.preventivo.prodotto.id === "IMC") {
      test = true;
    }

    var testAmount = false;
    if (parseFloat(self.supportModel.totalCespitiAmount) <= parseFloat(self.model.leasingData.preventivo.importo)) {
      testAmount = true;
    }

    var testVendor = false;
    if (getWizardMap(self.model.viewIndex) == "M15") {
      testVendor = !oninit ? self.checkVendor : cespiteOk;
    } else {
      testVendor = true;
    }
    // Test sull'inserimento del soggetto assicurato non più obbligatorio
    // var testInsured = false;
    // if (self.supportModel.insuredIsVisible) {
    //   testInsured = self.checkInsuredSub;
    // } else {
    //   testInsured = true;
    // }

    if (test && testAmount && testVendor) {
      self.supportModel.enableConfButton = true;
      self.pageIsOk();

    } else {
      self.supportModel.enableConfButton = false;
      self.pageIsNotOk();
    }
    if (self.supportModel.isM12 == false) {
      verificaComponenti();
    }
  }

  var paymentModes = function (prodotto, reteVendita, cespite) {
    var usato = undefined;
    $financialApiService
      .providerPaymentModes(prodotto, reteVendita, self.model.leasingData.preventivo.cdRaggrConvenzione, usato, self.model.financialVendor.riUserG.ndg, self.model.leasingData.preventivo.agevolazioni, self.model.leasingData.preventivo.fornitore.modPagamento.id)
      .then(function (response) {
        self.supportModel.allPaymentMode = response.modPagamento;

      }).catch(function (error) {
        console.error(error);
      });
  }

  var checkAndEnableTooltip = function () {
    $timeout(function () {
      if (self.model.financialCustomer.metadata.riUserG.ragioneSociale &&
        self.model.financialCustomer.metadata.riUserG.ragioneSociale.length > self.numberOfCharMax) {
        self.enableToltipCepiteCli = true;
      }
    }, 500);
  }

  var getWizardMap = function (viewIndex) {
    return $rootScope.wizardMap.find(function (element) {
      return element.index == viewIndex;
    }).viewName;
  }

  var changeModPagamento = function (cespite) {
    if (self.model.leasingData.preventivo.fornitore && !self.model.leasingData.preventivo.fornitore.cfPiva) {
      self.model.leasingData.preventivo.fornitore = cespite.fornitore;
    }
    self.model.leasingData.preventivo.fornitore.modPagamento.listaTranches.forEach(function (element) {
      if (!cespite.fornitore.modPagamento.listaTranches) {
        cespite.fornitore.modPagamento.id = self.model.leasingData.preventivo.fornitore.modPagamento.id;
        cespite.fornitore.modPagamento.description = self.model.leasingData.preventivo.fornitore.modPagamento.description;
        cespite.fornitore.modPagamento.listaTranches.push(Tranche.build({
          importoPagamento: Math.round(cespite.importoCespite * element.percentualePagamento) / 100,
          percentualePagamento: element.percentualePagamento,
          giorniDilazione: element.giorniDilazione
        }));
      }
    });

    $timeout(function () {
      paymentModes(self.model.leasingData.preventivo.prodotto.id, self.model.financialVendor.reteVendita, cespite);
    }, 1000);

  }

  var getNumberMaxOfCespiti = function () {
    $typeDomainService.getDomainSet("ADDITIONAL_INFO_ASSET", "MAX_GOODS").then(function (response) {
      self.supportModel.numberOfCespitiMax = parseInt(response.domainList[0].value);
      if (self.model.leasingData.preventivo.prodotto.beneContratto.length >= self.supportModel.numberOfCespitiMax) {
        self.supportModel.isMaxNumOfCespiti = true;
      } else {
        self.supportModel.isMaxNumOfCespiti = false;
      }
    });
  };

  self.provGoodIsOk = function () {
    self.checkProvGood = true;
    validateGoodManagement();
  }

  self.provGoodIsNotOk = function () {
    self.checkProvGood = false;
    validateGoodManagement();
  }

  self.vendorIsOk = function () {
    self.checkVendor = true;
    validateGoodManagement();
  }

  self.vendorIsNotOk = function () {
    self.checkVendor = false;
    validateGoodManagement();
  }

  self.addGoodIsOk = function () {
    self.checkAddGood = true;
    validateGoodManagement();
  }

  self.addGoodIsNotOk = function () {
    self.checkAddGood = false;
    validateGoodManagement();
  }

  self.addImmoIsOk = function () {
    self.checkImmo = true;
    validateGoodManagement();
  }

  self.addImmoIsNotOk = function () {
    self.checkImmo = false;
    validateGoodManagement();
  }

  self.registeredIsOk = function () {
    self.checkRegistered = true;
    validateGoodManagement();
  }

  self.registeredIsNotOk = function () {
    self.checkRegistered = false;
    validateGoodManagement();
  }

  self.boatIsOk = function () {
    self.checkBoat = true;
    validateGoodManagement();
  }

  self.boatIsNotOk = function () {
    self.checkBoat = false;
    validateGoodManagement();
  }

  self.flyIsOk = function () {
    self.checkFly = true;
    validateGoodManagement();
  }

  self.flyIsNotOk = function () {
    self.checkFly = false;
    validateGoodManagement();
  }

  self.insuredSubjectIsOk = function () {
    self.checkInsuredSub = true;
    validateGoodManagement();
  }

  self.insuredSubjectIsNotOk = function () {
    self.checkInsuredSub = false;
    validateGoodManagement();
  }

  var popolateControlCheckBox = function () {
    $typeDomainService
      .getDomainSet("CONSENSO_PRECONTRATTUALE", "M12")
      .then(function (response) {

        var test = self.model.leasingData.preventivo.flagsArc
          .some(function (element) {
            return element.name == response.domainList[0].name
          })
        if (!test) {
          self.model.leasingData.preventivo.flagsArc.push(FlagArc.build(response.domainList[0]));
        }

      })
  }

  self.check = function (el) {
    el.selected = !el.selected;
    validateGoodManagement();

  }
  self.showVerificaComponenti = false;
  self.showVerificaComponenti = function () {
    self.verificaComponentiIsVisible = self.verificaComponentiIsVisible ? false : true;
  }
  self.exportCf2 = function (newCf) {
    self.currentCf = newCf;
  }
  var verificaComponenti = function () {
    self.componentiMancanti = [];

    // CONTROLLO PRIMA SE HO UN TIPO DI BENE
    if (self.supportModel.elementToAdd.cdCategoriaBene != "" && self.supportModel.elementToAdd.cdCategoriaBene) {

      if (self.supportModel.elementToAdd.importoCespite == undefined || self.supportModel.elementToAdd.importoCespite > self.supportModel.initialAmount) {
        self.componentiMancanti.push("Importo");
      }
      if (self.supportModel.elementToAdd.dataDiConsegna == undefined && !self.supportModel.elementToAdd.beneProntaConsegna) {
        self.componentiMancanti.push("Data di consegna");
      }
      if (self.supportModel.elementToAdd.annoCostruzione == undefined) {
        self.componentiMancanti.push("Anno costruzione");
      }
      if (self.supportModel.elementToAdd.description == undefined || self.supportModel.elementToAdd.description == "") {
        self.componentiMancanti.push("Descrizione");
      }
      if (self.supportModel.elementToAdd.fornitore.accontiCompensazione == undefined) {
        self.componentiMancanti.push("Importo compensazione fornitore");
      }
      if (self.supportModel.elementToAdd.fornitore.accontiDaUsare == true) {
        if (self.supportModel.elementToAdd.fornitore.accontiCompensazione == 0 || self.supportModel.elementToAdd.fornitore.accontiCompensazione > self.supportModel.cespiteAmount) {
          self.componentiMancanti.push("Importo compensazione fornitore");
        }
      }
      if (self.supportModel.elementToAdd.cduCompatibileConAssicurazioni == false) {
        self.componentiMancanti.push("Tipo bene");
      }
      if (self.supportModel.elementToAdd.fornitore.estero == true) {
        if (self.supportModel.elementToAdd.fornitore.rappresentanteItalia == "" || self.supportModel.elementToAdd.fornitore.rappresentanteItalia == undefined) {
          self.componentiMancanti.push("Rappresentante fornitore estero");
        }
      }
      if (self.supportModel.elementToAdd.resa.id == null ||
        self.supportModel.elementToAdd.resa.description == null) {
        self.componentiMancanti.push("Resa");
      }

      //CONTROLLO SE UTENZA OVERMACH
      self.isOvermach = false;
      if (self.supportModel.elementToAdd.fornitore.isPersona == false) {
        var ragSocOvermach = "OVERMACH";
        if (self.supportModel.elementToAdd.fornitore.riUserG && self.supportModel.elementToAdd.fornitore.riUserG.ragioneSociale && self.supportModel.elementToAdd.fornitore.riUserG.ragioneSociale.toUpperCase().indexOf(ragSocOvermach) >= 0) {
          self.isOvermach = true;
        }
      }


      //SOLO CF MANCANTE CON ECCEZIONE PER DROPDOWN MENU SU UTENZA OVERMACH
      if (!self.isOvermach) {
        if (!self.currentCf) {
          self.componentiMancanti.push("Fornitore (CF/NDG)");
        }
      }

      if (self.supportModel.elementToAdd.fornitore.isPersona == true) {
        if (self.supportModel.elementToAdd.fornitore.riUserF.cf == "" ||
          self.supportModel.elementToAdd.fornitore.riUserF.nome == undefined ||
          self.supportModel.elementToAdd.fornitore.riUserF.cognome == undefined ||
          self.supportModel.elementToAdd.fornitore.riUserF.nome == "" ||
          self.supportModel.elementToAdd.fornitore.riUserF.cognome == "" ||
          self.supportModel.elementToAdd.fornitore.riUserF.residenza.provincia == undefined ||
          self.supportModel.elementToAdd.fornitore.riUserF.residenza.comune == undefined ||
          self.supportModel.elementToAdd.fornitore.riUserF.residenza.cap == undefined ||
          self.supportModel.elementToAdd.fornitore.riUserF.residenza.indirizzo == undefined ||
          self.supportModel.elementToAdd.fornitore.riUserF.residenza.numeroCivico == undefined) {
          self.componentiMancanti.push("Fornitore (dati incompleti)");
        }
      }
      if (self.supportModel.elementToAdd.fornitore.isPersona == false) {
        if (self.supportModel.elementToAdd.fornitore.riUserG.cf == undefined ||
          self.supportModel.elementToAdd.fornitore.riUserG.piva == undefined ||
          self.supportModel.elementToAdd.fornitore.riUserG.ragioneSociale == undefined ||
          self.supportModel.elementToAdd.fornitore.riUserG.ndg == undefined ||
          self.supportModel.elementToAdd.fornitore.riUserG.sedeLegale.indirizzo == undefined ||
          self.supportModel.elementToAdd.fornitore.riUserG.sedeLegale.comune == undefined ||
          self.supportModel.elementToAdd.fornitore.riUserG.sedeLegale.cap == undefined ||
          self.supportModel.elementToAdd.fornitore.riUserG.sedeLegale.provincia == undefined ||
          self.supportModel.elementToAdd.fornitore.riUserG.sedeLegale.numeroCivico == undefined ||
          self.supportModel.elementToAdd.fornitore.riUserG.inBlacklist) {
          self.componentiMancanti.push("Fornitore (dati incompleti o errati)");
        } else {
          self.checkFornitore = true;
        }
      }
      if (self.checkVendor == false && self.checkFornitore == true) {
        self.componentiMancanti.push("Modalità pagamento");
      }
      //SOGGETTO ASSICURATO
      if (self.supportModel.insuredIsVisible == true) {
        if (self.supportModel.elementToAdd.soggettoAssicurato == undefined || self.supportModel.elementToAdd.soggettoAssicurato.cf == undefined ||
          self.supportModel.elementToAdd.soggettoAssicurato.cognome == undefined ||
          self.supportModel.elementToAdd.soggettoAssicurato.cognome == "") {
          self.componentiMancanti.push("Dati soggetto assicurato");
        }
      }

      switch (self.model.leasingData.preventivo.prodotto.id) {
        case 'MOB':
        case 'FVM':
          // NUOVO INDIRIZZO STRUMENTALE
          if (self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserG.sedeConsegna.comune == null ||
            self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserG.sedeConsegna.cap == null ||
            self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserG.sedeConsegna.indirizzo == null ||
            self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserG.sedeConsegna.numeroCivico == null) {
            self.componentiMancanti.push("Indirizzo installazione bene");
          }
          //PROPRIETARIO IMMOBILE INSTALLAZIONE
          if (self.supportModel.elementToAdd.strumentale.clienteProprietarioImm == false) {
            // AZIENDA
            if (self.supportModel.elementToAdd.strumentale.proprietarioImmobile.isPersona == false) {
              if (self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserG.sedeLegale.comune == null ||
                self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserG.sedeLegale.cap == null ||
                self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserG.sedeLegale.indirizzo == null ||
                self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserG.sedeLegale.numeroCivico == null) {
                self.componentiMancanti.push("Proprietario immobile");
              }
            }
            // PERSONA
            if (self.supportModel.elementToAdd.strumentale.proprietarioImmobile.isPersona == true) {
              if (self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserF &&
                (self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserF.cf == "" ||
                  self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserF.nome == "" ||
                  self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserF.cognome == "" ||
                  self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserF.residenza.comune == null ||
                  self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserF.residenza.cap == null ||
                  self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserF.residenza.indirizzo == null ||
                  self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserF.residenza.numeroCivico == null)) {
                self.componentiMancanti.push("Proprietario immobile");
              }
            }
          }
          break;
        case 'NAV':
        case 'FLY':
          // NUOVO INDIRIZZO NAV-FLY
          if (self.supportModel.elementToAdd.flyNav.proprietarioImmobile.riUserG.sedeConsegna.comune == null ||
            self.supportModel.elementToAdd.flyNav.proprietarioImmobile.riUserG.sedeConsegna.cap == null ||
            self.supportModel.elementToAdd.flyNav.proprietarioImmobile.riUserG.sedeConsegna.indirizzo == null ||
            self.supportModel.elementToAdd.flyNav.proprietarioImmobile.riUserG.sedeConsegna.numeroCivico == null) {
            if (self.model.leasingData.preventivo.prodotto.id == "FLY") {
              self.componentiMancanti.push("Indirizzo deposito o aeroporto");
            } else {
              self.componentiMancanti.push("Indirizzo deposito o porto");
            }
          }
          //PROPRIETARIO IMMOBILE INSTALLAZIONE
          if (self.supportModel.elementToAdd.flyNav.clienteProprietarioImm == false) {
            // AZIENDA
            if (self.supportModel.elementToAdd.flyNav.proprietarioImmobile.isPersona == false) {
              if (self.supportModel.elementToAdd.flyNav.proprietarioImmobile.riUserG.sedeLegale.comune == undefined ||
                self.supportModel.elementToAdd.flyNav.proprietarioImmobile.riUserG.sedeLegale.cap == undefined ||
                self.supportModel.elementToAdd.flyNav.proprietarioImmobile.riUserG.sedeLegale.indirizzo == undefined ||
                self.supportModel.elementToAdd.flyNav.proprietarioImmobile.riUserG.sedeLegale.numeroCivico == undefined) {
                if (self.model.leasingData.preventivo.prodotto.id == "FLY") {
                  self.componentiMancanti.push("Proprietario deposito o aeroporto");
                } else {
                  self.componentiMancanti.push("Proprietario deposito o porto");
                }
              }
            }
            // PERSONA
            if (self.supportModel.elementToAdd.flyNav.proprietarioImmobile.isPersona == true) {
              if (self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserF &&
                (self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserF.cf == "" ||
                  self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserF.nome == "" ||
                  self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserF.cognome == "" ||
                  self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserF.residenza.comune == null ||
                  self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserF.residenza.cap == null ||
                  self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserF.residenza.indirizzo == null ||
                  self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserF.residenza.numeroCivico == null)) {
                if (self.model.leasingData.preventivo.prodotto.id == "FLY") {
                  self.componentiMancanti.push("Proprietario deposito o aeroporto");
                } else {
                  self.componentiMancanti.push("Proprietario deposito o porto");
                }
              }
            }
          }
          break;
        case 'FER':
          // NUOVO INDIRIZZO FERROVIARIO
          if (self.supportModel.elementToAdd.ferroviario.proprietarioImmobile.riUserG.sedeConsegna.comune == null ||
            self.supportModel.elementToAdd.ferroviario.proprietarioImmobile.riUserG.sedeConsegna.cap == null ||
            self.supportModel.elementToAdd.ferroviario.proprietarioImmobile.riUserG.sedeConsegna.indirizzo == null ||
            self.supportModel.elementToAdd.ferroviario.proprietarioImmobile.riUserG.sedeConsegna.numeroCivico == null) {
            self.componentiMancanti.push("Indirizzo installazione bene");
          }

          //PROPRIETARIO IMMOBILE INSTALLAZIONE
          if (self.supportModel.elementToAdd.ferroviario.clienteProprietarioImm == false) {
            // AZIENDA
            if (self.supportModel.elementToAdd.ferroviario.proprietarioImmobile.isPersona == false) {
              if (self.supportModel.elementToAdd.ferroviario.proprietarioImmobile.riUserG.sedeLegale.comune == null ||
                self.supportModel.elementToAdd.ferroviario.proprietarioImmobile.riUserG.sedeLegale.cap == null ||
                self.supportModel.elementToAdd.ferroviario.proprietarioImmobile.riUserG.sedeLegale.indirizzo == null ||
                self.supportModel.elementToAdd.ferroviario.proprietarioImmobile.riUserG.sedeLegale.numeroCivico == null) {
                self.componentiMancanti.push("Proprietario immobile");
              }
            }
            // PERSONA
            if (self.supportModel.elementToAdd.ferroviario.proprietarioImmobile.isPersona == true) {
              if (self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserF &&
                (self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserF.cf == "" ||
                  self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserF.nome == "" ||
                  self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserF.cognome == "" ||
                  self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserF.residenza.comune == null ||
                  self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserF.residenza.cap == null ||
                  self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserF.residenza.indirizzo == null ||
                  self.supportModel.elementToAdd.strumentale.proprietarioImmobile.riUserF.residenza.numeroCivico == null)) {
                self.componentiMancanti.push("Proprietario immobile");
              }
            }
          }
          break;
        case 'AVC':
        case 'AVT':
        case 'AVI':
        case 'MOT':
          // DATI VEICOLO
          if (self.supportModel.elementToAdd.targato.marcaVeicolo.id == undefined ||
            self.supportModel.elementToAdd.targato.marcaVeicolo.modello.length == 0 ||
            self.checkRegistered == false) {
            self.componentiMancanti.push("Informazioni aggiuntive sul bene");
          }
          if (self.model.leasingData.preventivo.prodotto.id == "AVC" ||
            self.model.leasingData.preventivo.prodotto.id == "AVT") {
            if (self.supportModel.elementToAdd.targato.quotaEsente > self.supportModel.elementToAdd.importoCespite) {
              self.componentiMancanti.push("Quota esente");
            }
          }
          if (self.supportModel.elementToAdd.stato == "LBL_GOOD_STATE_NOT_NEW") {
            if (self.supportModel.elementToAdd.targato.targaVeicolo == undefined ||
              self.supportModel.elementToAdd.targato.telaioVeicolo == undefined) {
              self.componentiMancanti.push("Informazioni aggiuntive sul bene");
            }
          }
          break;
        case 'IMM':
          if (self.supportModel.elementToAdd.immobiliare.regimeApplicabile == "imposta di registro") {
            if (self.supportModel.elementToAdd.quotaEsente == 0 || self.supportModel.elementToAdd.quotaEsente > self.supportModel.elementToAdd.importoCespite) {
              self.componentiMancanti.push("Quota esente");
            }
          }
          if (self.supportModel.elementToAdd.immobiliare.indirizzoImmobile.provincia == null ||
            self.supportModel.elementToAdd.immobiliare.indirizzoImmobile.comune == null ||
            self.supportModel.elementToAdd.immobiliare.indirizzoImmobile.cap == null ||
            self.supportModel.elementToAdd.immobiliare.indirizzoImmobile.indirizzo == null) {
            self.componentiMancanti.push("Indiizzo ubicazione bene");
          }
          break;
      }
    } else {
      self.componentiMancanti.push("Tipo di bene");
    }
  }
}